import {StateInvoices} from '../../invoices.model';
import {createFeatureSelector, MemoizedSelector} from '@ngrx/store';

export const INVOICES_FEATURE = 'invoices';

export interface StateWithInvoices {
  [INVOICES_FEATURE]: StateInvoices;
}

export const getInvoicesState: MemoizedSelector<StateWithInvoices, StateInvoices> =
  createFeatureSelector<StateInvoices>(INVOICES_FEATURE);


